var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6555 7.14863L11.8367 9.60863L12.6811 13.2711C12.7258 13.4626 12.713 13.663 12.6445 13.8472C12.5759 14.0315 12.4545 14.1914 12.2955 14.3071C12.1365 14.4227 11.9469 14.489 11.7505 14.4975C11.5541 14.5059 11.3595 14.4564 11.1911 14.3549L7.99673 12.4174L4.80923 14.3549C4.64084 14.4564 4.44627 14.5059 4.24984 14.4975C4.05342 14.489 3.86385 14.4227 3.70485 14.3071C3.54586 14.1914 3.42447 14.0315 3.35589 13.8472C3.2873 13.663 3.27455 13.4626 3.31923 13.2711L4.16236 9.61238L1.34298 7.14863C1.19386 7.02002 1.08603 6.85024 1.03302 6.66059C0.980001 6.47094 0.984157 6.26986 1.04497 6.08257C1.10577 5.89527 1.22052 5.7301 1.37483 5.60776C1.52914 5.48542 1.71613 5.41137 1.91236 5.39488L5.62861 5.073L7.07923 1.613C7.15499 1.43145 7.28276 1.27637 7.44647 1.16729C7.61018 1.05821 7.80251 1 7.99923 1C8.19596 1 8.38828 1.05821 8.55199 1.16729C8.7157 1.27637 8.84348 1.43145 8.91923 1.613L10.3742 5.073L14.0892 5.39488C14.2855 5.41137 14.4725 5.48542 14.6268 5.60776C14.7811 5.7301 14.8958 5.89527 14.9566 6.08257C15.0174 6.26986 15.0216 6.47094 14.9686 6.66059C14.9156 6.85024 14.8077 7.02002 14.6586 7.14863H14.6555Z",
    fill: "#E5C100"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowStar);
export default __webpack_public_path__ + "static/media/yellow-star.8503f61dfbe87067e53c5fb43f1afab1.svg";
export { ForwardRef as ReactComponent };